<template>
  <div>
    <vue-content-loading
      :width="config.width"
      :height="config.height"
      v-for="(n, ican) in config.cantidad"
      :key="`cl-${ican}`"
    >
      <rect x="0" y="0" rx="2" ry="2" :width="config.width" :height="config.height" />
    </vue-content-loading>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueContentLoading } from "vue-content-loading"
export default {
  props: ["config"],
  name: "loadingUtil",
  components: {
    VueContentLoading
  },
  mounted() {},
  beforeCreate() {},
  methods: {}
}
</script>
